// assets/js/components/ui-components/notificationQueue.js
//
// Sequences "auto-show" UI overlays (support chat, ...) so they never
// appear on top of each other on first page load. Callers register in the order they
// should get a turn; nothing shows until unlock() is called (by whatever decides the
// cookie banner is resolved — see app.js), and each shown item must call advance() when
// it's done with its turn before the next eligible item gets shown.
class NotificationQueueClass {
    constructor() {
        this._items = [];
        this._unlocked = false;
        this._advancing = false;
    }

    register(item) {
        // `order` is explicit rather than relying on call order, since callers register
        // from different modules whose execution order isn't guaranteed.
        const order = typeof item.order === 'number' ? item.order : this._items.length;
        this._items.push({ ...item, order });
        this._items.sort((a, b) => a.order - b.order);

        // unlock() may have already run before this item registered (registration order
        // across modules isn't guaranteed) — give it a turn now
        // instead of waiting for an advance() call that will never come.
        if (this._unlocked && !this._advancing) {
            this._runNext();
        }
    }

    unlock() {
        if (this._unlocked) return;
        this._unlocked = true;
        this._runNext();
    }

    advance() {
        this._advancing = false;
        this._runNext();
    }

    _runNext() {
        if (!this._unlocked || this._advancing) return;

        while (this._items.length) {
            const item = this._items.shift();
            if (item.isEligible()) {
                this._advancing = true;
                item.show();
                return;
            }
        }
    }
}

export const NotificationQueue = new NotificationQueueClass();
window.NotificationQueue = NotificationQueue;
